import { createContext, useContext, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getModuleFromPath, getBlockFromPath, THEMES } from '../config/themes'

const ThemeContext = createContext(null)

export function ThemeProvider({ children, initialTheme = 'chatrone', onThemeChange }) {
  const [theme, setTheme] = useState(initialTheme)
  const location = useLocation()
  const module = getModuleFromPath(location.pathname)
  const block = getBlockFromPath(location.pathname, location.search)

  // Sync when parent provides a loaded profile value
  useEffect(() => {
    if (initialTheme && THEMES[initialTheme]) setTheme(initialTheme)
  }, [initialTheme])

  const changeTheme = (newTheme) => {
    if (!THEMES[newTheme]) return
    setTheme(newTheme)
    onThemeChange?.(newTheme)
  }

  return (
    <ThemeContext.Provider value={{ theme, module, block, changeTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  )
}

// Safe — returns midnight defaults when used outside ThemeProvider (e.g. TopBar in standalone tests)
export function useTheme() {
  const ctx = useContext(ThemeContext)
  if (!ctx) return { theme: 'midnight', module: 'default', block: 'universal', changeTheme: () => {}, themes: THEMES }
  return ctx
}
